import React, { useCallback } from 'react';
import { Tappable, Icon } from '@vectord/components';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import {
  BLACKLIST_ADD_MODAL_STAGES,
  setPersonalisedMenteeEmailersAddModalStage,
  setPersonalisedMenteeEmailersFilterModalState,
} from 'features/communicationManagement';
import styles from './PersonalisedMenteeEmailersHeaderActionables.module.scss';

export default function PersonalisedMenteeEmailersHeaderActionables() {
  const dispatch = useDispatch();

  const handleAddLearnerSnooze = useCallback(() => {
    dispatch(
      setPersonalisedMenteeEmailersAddModalStage(BLACKLIST_ADD_MODAL_STAGES.add)
    );
  }, [dispatch]);

  const handleFilterClick = useCallback(() => {
    dispatch(setPersonalisedMenteeEmailersFilterModalState(true));
  }, [dispatch]);

  return (
    <div className={classNames(styles.container, 'm-l-xs')}>
      <Tappable
        className={classNames(styles.filter, 'btn btn-inverted')}
        onClick={handleFilterClick}
      >
        <Icon
          name="filter-alt"
          className="p-t-xxs m-r-xxs h5 cursor"
        />
        Filter
      </Tappable>
      <Tappable
        className={classNames(styles.addLearnerButton, 'p-v-xxs', 'p-h-xs')}
        onClick={handleAddLearnerSnooze}
      >
        <Icon
          name="person-plus"
          className="m-r-xxs"
        />
        Add Learner
      </Tappable>
    </div>
  );
}
